import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { messageStatusFilterOptions } from "./messageStatus";

const ChevronIcon = () => (
    <svg
        aria-hidden="true"
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <path d="m6 9 6 6 6-6" />
    </svg>
);

export default function MessageStatusFilter({ value, onChange }) {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const rootRef = useRef(null);
    const options = messageStatusFilterOptions(t);
    const selected =
        options.find((option) => option.value === value) || options[0];

    useEffect(() => {
        const onDocumentClick = (event) => {
            if (!rootRef.current?.contains(event.target)) {
                setOpen(false);
            }
        };
        const onKeyDown = (event) => {
            if (event.key === "Escape") {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", onDocumentClick);
        document.addEventListener("keydown", onKeyDown);
        return () => {
            document.removeEventListener("mousedown", onDocumentClick);
            document.removeEventListener("keydown", onKeyDown);
        };
    }, []);

    return (
        <div className="message-status-filter" ref={rootRef}>
            <span className="message-status-filter__label" id="message-status-filter-label">
                {t("Organizational.Messages.MessagesStatus")}
            </span>
            <button
                type="button"
                className="message-status-filter__trigger"
                aria-haspopup="listbox"
                aria-expanded={open}
                aria-labelledby="message-status-filter-label"
                onClick={() => setOpen((current) => !current)}
            >
                <span className="message-status-filter__value">
                    {selected.label}
                </span>
                <ChevronIcon />
            </button>
            {open ? (
                <ul
                    className="message-status-filter__menu"
                    role="listbox"
                    aria-labelledby="message-status-filter-label"
                >
                    {options.map((option) => (
                        <li key={option.value || "all"} role="none">
                            <button
                                type="button"
                                role="option"
                                aria-selected={option.value === value}
                                className={
                                    "message-status-filter__option" +
                                    (option.value === value
                                        ? " is-selected"
                                        : "")
                                }
                                onClick={() => {
                                    onChange(option.value);
                                    setOpen(false);
                                }}
                            >
                                {option.label}
                            </button>
                        </li>
                    ))}
                </ul>
            ) : null}
        </div>
    );
}
